import { ChangeEvent, FC, useState, useRef, MouseEvent, useEffect } from "react";
import { _ } from "../../utils/helpers";
import { useApp } from "../../context/useApp";
import { PersonalDetailKey } from "../../types";
import { InputText } from "../../parts/inputs/InputText";
import { InputSelect, SelectEvent, SelectOption } from "../../parts/inputs/InputSelect";
import { CheckBox } from "../../parts/inputs/CheckBox";
import { Switch } from "../../parts/inputs/Switch";
import { Textarea } from "../../parts/inputs/Textarea";
import { ButtonPromise, ButtonPromiseHandle } from "../../parts/inputs/ButtonPromise";
import { ROUTES, rumba, SCREEN_BREAKPOINT_1, timeOuts } from "../../utils/symbols";
import { CountriesOptions } from "../../utils/countries";
import { Icon } from "../../parts/Icon";

export const ContactDetails: FC = ({}) => {

    const {
        state: { booking, shifts, screen },
        actions: { genericError, navigate }
    } = useApp()

    const [showComments, setShowComments] = useState<boolean>(booking.notes !== '')
    const [discountCode, setDiscountCode] = useState<string>('')

    const applyDiscountButton = useRef<ButtonPromiseHandle>(null)
    const shift = shifts.find(shift => shift.id === booking.shiftId)

    const handleInputChange =  (event: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLTextAreaElement>) => {
        const {id, value} = event.currentTarget
        booking.setPersonalDetail(id as PersonalDetailKey, value.trimStart()).render()
    }

    const handleShowComments = (newValue: boolean) => {
        setShowComments(newValue)
        if (!newValue) booking.setPersonalDetail('notes', '').render()
    }

    const validateDiscountCode = async () => {
        applyDiscountButton.current!.loading()
        
        const error = () => {
            applyDiscountButton.current!.error()
            setDiscountCode('')
            booking.setPersonalDetail('discountCode', '').render()
            timeOuts.set('validateDiscountCode', () => applyDiscountButton.current!.finally(), 3000)
        }; //do this when discount is not valid

        const response = await rumba.validateDiscountCode(discountCode)
        if (response.result !== 'ok') { genericError(validateDiscountCode); return }//this when discount request fail

        applyDiscountButton.current!.success()
        booking.setPersonalDetail('discountCode', discountCode).render()
    }

    const handleDiscountCodeInputChange = (event: ChangeEvent<HTMLInputElement>) => {
        timeOuts.clear('validateDiscountCode')
        applyDiscountButton.current!.finally()
        setDiscountCode(event.currentTarget.value)
        booking.setPersonalDetail('discountCode', '').render()
    }

    const handleGoBack = (event: MouseEvent<HTMLButtonElement>) => {
        booking.setBookingStep('products').render()
        navigate(ROUTES.TABLE_LAYOUT)
    }

    return (
        <>
        <button 
            type="button"
            className="button b-0 p-0 df aic mb-7" 
            onClick={handleGoBack}
        >
            <Icon icon={'arrow'} className="rt180 mr-5"/>
            <p className="text s18-600">{_('0ge_gobac__')}</p>
        </button>
        <fieldset id="contact-details" className="w-100">
            <legend className="text s24-600 mb-8">{_('5ci_enter__')}</legend>
            <div className="df jcsb w-100 aic form-row mb-7">
                <InputText 
                    id="name"
                    autoComplete="name"
                    value={booking.name}
                    onChange={handleInputChange}
                    placeholder={_('0ge_namea__')+"*"}
                    required
                    getError={(name) => booking.validatePersonalDetail({
                        field: 'name', 
                        checkFieldAs: name,
                        shift: shift!
                    })[0]}
                />
            </div>
            <div className="df jcsb w-100 aifs form-row mb-8">
                <InputText 
                    id="email"
                    required
                    autoComplete="email"
                    value={booking.email}
                    onChange={handleInputChange}
                    placeholder={_('0ge_email__')+"*"}
                    getError={(email) => booking.validatePersonalDetail({
                        field: 'email', 
                        checkFieldAs: email,
                        shift: shift!
                    })[0]}
                />
                {   shift && !!shift.phoneRequired && (

                    <div className="df w-100 ml-7">
                        {/* <InputText 
                            id="prefix"
                            type="tel"
                            autoComplete="off"
                            value={booking.phone.prefix}
                            onChange={handleInputChange}
                            placeholder="+00"
                            maxLength={5}
                            showErrorMessage={false}
                            getError={(prefix) => booking.validatePersonalDetail({
                                field: 'prefix', 
                                checkFieldAs: prefix,
                                shift: shift!
                            })[0]}
                        /> */}
                        <InputText 
                            id="number"
                            type="tel"
                            required
                            autoComplete="tel"
                            maxLength={30}
                            value={booking.phone.number}
                            onChange={handleInputChange}
                            placeholder={_('0ge_phone__')+"*"}
                            getError={(number) => booking.validatePersonalDetail({
                                field: 'number', 
                                checkFieldAs: number,
                                shift: shift!
                            })[0]}
                        />
                    </div>
                )}
            </div>
            {/* <div className="df jcsb w-100 aifs form-row mb-8">
                <InputSelect 
                    id="country"
                    searchable
                    onSelect={(selectedOption) => booking.setPersonalDetail('country', selectedOption.option.value as string).render()}
                    options={CountriesOptions}
                    value={booking.country}
                    placeholder={_('0ge_count__')}
                    getError={(country) => booking.validatePersonalDetail({
                        field: 'country', 
                        checkFieldAs: country as string,
                        shift: shift!
                    })[0]}
                />
                <InputText 
                    id="discountCode"
                    value={discountCode}
                    onChange={handleDiscountCodeInputChange}
                    placeholder={_('5ci_promo__')}
                >
                    <ButtonPromise 
                        ref={applyDiscountButton}
                        className="slot-button text s19-600 px-8 o-h fs-0"
                        onClick={event => {
                            event.preventDefault()
                            validateDiscountCode()
                        }}
                        disabled={discountCode === '' || discountCode === booking.discountCode}
                    >
                        {_('0ge_apply__')}
                    </ButtonPromise>
                </InputText>
            </div> */}
            <div className="df jcsb w-100 aifs form-row">
                <Switch 
                    value={showComments} 
                    onChange={handleShowComments}
                    className="text s18-400 w-100 jcfe fd-rr aifs"
                >
                        <span className="mr-5">{_('5ci_addco__')}</span>
                </Switch>
            </div>
            <div className={`w-100 aifs form-row ${showComments ? '' : 'hidden'} mt-4 mb-7`}>
                <Textarea 
                    id="notes" 
                    value={booking.notes} 
                    placeholder={_('5ci_addco__')} 
                    onChange={handleInputChange}
                    maxLength={250}
                    getError={(notes) => booking.validatePersonalDetail({
                        field: 'notes', 
                        checkFieldAs: notes,
                        shift: shift!
                    })[0]}
                />
                <Switch 
                    value={booking.access > 0} 
                    onChange={(event) => booking.setAccess(event ? 2 : 0).render()}
                    className="text s18-400 w-100 jcfe fd-rr aifs mt-8"
                >
                    <span><Icon icon="reduced-mobility" style={{scale: '0.9'}} className="mr-3"/>{_('5ci_ineed__')}</span>
                </Switch>
            </div>
            <CheckBox
                    getError={checked => booking.validatePersonalDetail({field: 'acceptedTerms', checkFieldAs: checked, shift: shift!})[0]}
                    id="accepted-terms"
                    type="checkbox"
                    className="mr-5 mb-5"
                    required
                    checked={booking.acceptedTerms}
                    aria-labelledby="terms-label-text"
                    onChange={(event) => booking.setAcceptedTerms(event.currentTarget.checked).render() }
                >
                    <span 
                        id="terms-label-text" 
                        aria-hidden
                        dangerouslySetInnerHTML={{__html: _('5tc_iagre__')}}
                    ></span>
                </CheckBox>
        </fieldset>
        </>
    )
}